import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import { FmButton } from './FmButton';
import type { FmTextFieldTrailingSubmitDescriptor } from './FmForm.types';

interface FmTextFieldTrailingSubmitProps {
  descriptor?: FmTextFieldTrailingSubmitDescriptor;
  fieldDisabled?: boolean;
}

/** DS-owned submit affordance for the trailing slot of a single-line text field. */
export function FmTextFieldTrailingSubmit({
  descriptor,
  fieldDisabled,
}: FmTextFieldTrailingSubmitProps): React.ReactElement | undefined {
  if (!descriptor) return undefined;
  return (
    <FmButton
      type="submit"
      variant="primary"
      size="sm"
      className="fm-text-field__trailing-submit"
      aria-label={descriptor.ariaLabel}
      disabled={fieldDisabled || descriptor.disabled}
      data-testid={descriptor.testId}
      leadingIcon={<ArrowRightOutlined />}
    />
  );
}
